'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _InputStyle = require('./InputStyle.scss');

var _InputStyle2 = _interopRequireDefault(_InputStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_dec = (0, _reactCssModules2.default)(_InputStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Input, _React$Component);

  function Input() {
    (0, _classCallCheck3.default)(this, Input);
    return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
  }

  (0, _createClass3.default)(Input, [{
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      var enterKeyPressed = e.keyCode === 13;
      if (enterKeyPressed) {
        this.props.onReturn(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          additionalStyles = _props.additionalStyles,
          inputProps = (0, _objectWithoutProperties3.default)(_props, ['additionalStyles']);

      delete inputProps.styles;
      delete inputProps.onReturn;

      return _react2.default.createElement('input', (0, _extends3.default)({
        styleName: 'a-input ' + additionalStyles
      }, inputProps, {
        onKeyDown: this.handleKeyDown.bind(this)
      }));
    }
  }]);
  return Input;
}(_react2.default.Component), _class2.propTypes = {
  name: _react.PropTypes.string,
  additionalStyles: _react.PropTypes.string,
  type: _react.PropTypes.string,
  onReturn: _react.PropTypes.func
}, _class2.defaultProps = {
  type: 'text',
  additionalStyles: '',
  onReturn: function onReturn() {}
}, _temp)) || _class);
exports.default = Input;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/Input.js
// module id = 2468
// module chunks = 0